import type { FC, ReactNode } from "react";
import IconUneditable from "../../assets/icon-uneditable.svg";
import { cn } from "./utils/cn";

export interface LabelProps {
  children: ReactNode;
  /** Shows a small required dot. */
  required?: boolean;
  /** Shows the "uneditable" lock icon (e.g. disabled / read-only field). */
  readOnly?: boolean;
  htmlFor?: string;
  className?: string;
}

/**
 * Field label. Renders a real <label htmlFor> (unlike common/InputLabel, which
 * rendered a <div>). The default info icon from InputLabel is intentionally
 * dropped — use ui/InfoTooltip alongside the label when help text is needed.
 */
const Label: FC<LabelProps> = ({
  children,
  required,
  readOnly,
  htmlFor,
  className,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        "mb-1.5 flex items-center gap-2 text-start text-sm font-medium text-menu/80",
        className
      )}
    >
      <span>{children}</span>
      {required && !readOnly && (
        <span className="h-2 w-2 rounded-pill bg-danger" />
      )}
      {readOnly && (
        <img
          className="h-4 w-4"
          src={IconUneditable}
          alt=""
          aria-hidden="true"
        />
      )}
    </label>
  );
};

export default Label;
